import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  button: {
    display: 'flex',
    justifyContent: 'space-around',
    width: 'calc(100% - 30px)',
    height: '50px',
    position: 'fixed',
    bottom: 15,
    marginLeft: '15px',
    backgroundColor: '#F97F11',
    color: '#FFF',
    '&:hover': {
      backgroundColor: '#F97F11',
    },
  },
  title: {
    fontSize: 14,
  },
}));

export default useStyles;
